{
  "unitSelect": {
    "unit": "Units",
    "select": "Select"
  },
  "popConfirm": {
    "confirm_delete_message": "Do you want to delete element?"
  },
  "select": {
    "unselect": "Not selected"
  },
  "queryBuilder": {
    "from": "From",
    "to": "To"
  }
}